const actions = {
    SET_STATE: "plans/SET_STATE",
    GET_PLANS: "plans/GET_PLANS"
};

export default actions;
